import { render, staticRenderFns } from "./CardLive2.vue?vue&type=template&id=35217ec8&scoped=true&"
import script from "./CardLive2.vue?vue&type=script&lang=js&"
export * from "./CardLive2.vue?vue&type=script&lang=js&"
import style0 from "./CardLive2.vue?vue&type=style&index=0&id=35217ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35217ec8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSpacer})
